import { RoverEnvironment } from './constants';

export function determineEnvironmentFromApiBase(
  apiBase: string | null | undefined
): RoverEnvironment {
  if (!apiBase) {
    return RoverEnvironment.DEVELOPMENT;
  }

  if (apiBase.endsWith('.rover.com')) {
    return RoverEnvironment.PRODUCTION;
  }

  if (apiBase.endsWith('.roverstaging.com')) {
    return RoverEnvironment.STAGING;
  }

  return RoverEnvironment.DEVELOPMENT;
}

export function getApiEnvironmentName(apiBase: string | null | undefined): RoverEnvironment {
  return determineEnvironmentFromApiBase(apiBase);
}

export function isProdRoverEnv(apiBase: string | null | undefined): boolean {
  return determineEnvironmentFromApiBase(apiBase) === RoverEnvironment.PRODUCTION;
}

export function isStagingRoverEnv(apiBase: string | null | undefined): boolean {
  return determineEnvironmentFromApiBase(apiBase) === RoverEnvironment.STAGING;
}

export function isDevRoverEnv(apiBase: string | null | undefined): boolean {
  return determineEnvironmentFromApiBase(apiBase) === RoverEnvironment.DEVELOPMENT;
}
